import { baseApi } from '@ibk/shared-config';
export const bankslipApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        createBankslip: builder.mutation({
            query: data => ({
                url: '/v1/bankslip',
                method: 'POST',
                body: data,
                forceSelectedAccountInfoAccountId: true,
                forceAccountantApiBaseUrl: true,
                timeout: 50000,
            }),
        }),
    }),
});
export const { useCreateBankslipMutation } = bankslipApi;
